const environment = {
	prod: true,
	mock: 'undefined',
	api: 'https://api.danamas.co.id:8443',
	authUsername: 'poc_admin',
	authPassword: '8ce682c17b83d4301d3ced01a95141f77d07ac6a',
};

export default environment;
